module.exports = __webpack_public_path__ + "img/history.819c80ae.svg";